import * as ACTIONS from './constants';

// services
import { getFavourites, favouriteRange, unFavouriteRange, getRecentlyViewed } from '../services/activityService';

function sameRanges(currentRanges, newRanges) {
  if(!currentRanges || !currentRanges.length) return false;
  return currentRanges.every((range, i) => range.catNo === newRanges[i]);
}

export const updateFavourites = () => (dispatch, getState) => {
  const { user, activity } = getState();
  return getFavourites(user.userGuid).then((favourites) => {
    const newFavs = favourites.sort((a, b) => a.catNo - b.catNo);
    if(sameRanges(activity.favourites, newFavs)) return newFavs;
    dispatch({ type: ACTIONS.UPDATE_FAVOURITES, payload: newFavs });
    return newFavs;
  });
};

export const updateRecent = () => (dispatch, getState) => {
  const { user, activity } = getState();
  return getRecentlyViewed(user.userGuid).then((recent) => {
    const newRecent = recent.sort((a, b) => a.catNo - b.catNo);
    if(sameRanges(activity.recent, newRecent)) return;
    dispatch({ type: ACTIONS.UPDATE_RECENT, payload: newRecent });
  });
};

export const updateActivity = () => (dispatch, getState) => {
  const { user, activity } = getState();
  return Promise.all([
    getFavourites(user.userGuid).then((favourites) => {
      const newFavs = favourites.sort((a, b) => a.catNo - b.catNo);
      if(sameRanges(activity.favourites, newFavs)) return;
      dispatch({ type: ACTIONS.UPDATE_FAVOURITES, payload: newFavs });
    }),
    getRecentlyViewed(user.userGuid).then((recent) => {
      const newRecent = recent.sort((a, b) => a.catNo - b.catNo);
      if(sameRanges(activity.recent, newRecent)) return;
      dispatch({ type: ACTIONS.UPDATE_RECENT, payload: newRecent });
    })
  ]);
};

export const addRangeAsFavourite = (rangeName, sku) => (dispatch, getState) => {
  const { userGuid } = getState().user;
  return favouriteRange(userGuid, rangeName, sku)
    .then(() => dispatch(updateFavourites()));
};

export const removeRangeAsFavourite = rangeName => (dispatch, getState) => {
  const { userGuid } = getState().user;
  return unFavouriteRange(userGuid, rangeName)
    .then(() => dispatch(updateFavourites()));
};




// WEBPACK FOOTER //
// ./src/actions/activity.js